module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dropdown-item', _vm._b({}, 'el-dropdown-item', _vm.$attrs, false), [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ee42012"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/dropdown/rtDropdownItem.vue
// module id = 1485
// module chunks = 91